import { findEditorTypeList, saveDiviceType, removeType } from '@/api/device'
const state = {
  permissions: [],
  user:{},
}

const actions = {
}

const mutations = {
  SET_PERMISSIONS(state, permissions) {
    state.permissions = [].concat(permissions);
  },
  SET_USER(state, user) {
    state.user = user;
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
